import {Component, inject, signal} from '@angular/core';
import {ArchitecturalPrinciple} from '@frontend/directus';
import {HrToolService} from '../hr-tool.service';
import {HrToolProviderGroup} from '../hr-tool.types';
import {HrToolProviderModalComponent} from '../hr-tool-provider-modal/hr-tool-provider-modal.component';
import {NoDataComponent} from '../../../shared/components/no-data/no-data.component';

@Component({
  selector: 'app-hr-tool-selection',
  imports: [HrToolProviderModalComponent, NoDataComponent],
  templateUrl: './hr-tool-selection.component.html',
})
export class HrToolSelectionComponent {
  private readonly hrToolsService = inject(HrToolService);

  protected readonly providerGroups = this.hrToolsService.providerGroups;

  protected applicationTypeIcon(type: ArchitecturalPrinciple): string {
    return this.hrToolsService.applicationTypeIcon(type);
  }

  protected applicationTypeLabel(type: ArchitecturalPrinciple): string {
    return this.hrToolsService.applicationTypeLabel(type);
  }
  protected readonly selectedGroup = signal<HrToolProviderGroup | null>(null);
  protected modalVisible = signal(false);
  private readonly brokenLogos = signal<Set<string>>(new Set());

  protected showLogo(group: HrToolProviderGroup): boolean {
    return !!group.logoUrl && !this.brokenLogos().has(group.id);
  }

  protected onLogoError(group: HrToolProviderGroup): void {
    this.brokenLogos.update((broken) => new Set(broken).add(group.id));
  }

  protected openProvider(group: HrToolProviderGroup): void {
    this.selectedGroup.set(group);
    this.modalVisible.set(true);
  }
}
